<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title
          class="primary accent--text title font-weight-thin mb-5"
        >
          User Account
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="model.firstName"
                dense
                outlined
                type="text"
                label="First Name"
                required
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="model.lastName"
                dense
                outlined
                type="text"
                label="Last Name"
                required
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="model.email"
                dense
                outlined
                type="email"
                label="Email"
                required
              />
            </v-col>
            <v-col cols="12">
              <international-phone-number
                @change="onPhoneNumberChange"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="model.role"
                outlined
                dense
                :items="roles"
                label="Role"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="sendInvite"
                dense
                color="primary"
                :label="`Send email invitation: ${ sendInvite ? 'Yes' : 'No'}`"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-divider class="mb-5" />
      <v-btn
        outlined
        rounded
        :disabled="!changesMade || isLoading"
        :loading="isLoading"
        color="primary"
        class="mr-3"
        @click="save"
      >
        Save
      </v-btn>

      <v-btn
        outlined
        rounded
        text
        :disabled="!changesMade || isLoading"
        @click="cancel"
      >
        Cancel
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
  import { isEmpty } from 'lodash'
  import { mapGetters, mapActions } from 'vuex'
  import InternationalPhoneNumber from "../Common/InternationalPhoneNumber"
  import drawers from "../../stores/modules/drawers"

  export default {
    components: { InternationalPhoneNumber },
    props: {
      dialog: {
        type: Boolean
      },
      user: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        isLoading: false,
        sendInvite: true,
        model: {
          firstName: '',
          lastName: '',
          email: '',
          phoneNumber: '',
          role: '',
        },
        // replace with config later
        roles: [
          'owner',
          'admin',
          'staff'
        ]
      }
    },
    computed: {
      changesMade() {
        return JSON.stringify(this.model) !== JSON.stringify(this.user)
      },
    },
    created() {
      this.model = { ...this.user }
    },
    methods: {
      ...mapActions([ 'createTenantUser' ]),
      onPhoneNumberChange(phone){
        this.model = {
          ...this.model,
          phoneNumber: phone.number
        }
      },
      isCreateMode() {
        return isEmpty(this.model.id)
      },
      async save() {
        const payload = {
          ...this.model,
          sendInvite: this.sendInvite,
        }

        this.isLoading = true
        await this.createTenantUser(payload)
          .then(() => { this.$router.push({ name: 'users' })})

        this.isLoading = false
      },
      emitSave() {
        this.$emit('save-form', { ...this.model })

        // This case is for when its the HeaderBarAction
        this.$emit('close-dialog', this.model.uid)
      },
      cancel() {
        this.$router.push({ name: 'users'})
      }
    }
  }
</script>
